const GetUserAccessToken = () => {
  const accessToken = window.localStorage.getItem('user_access_token');

  return accessToken;
};

export default GetUserAccessToken;
